import { render, staticRenderFns } from "./ComparativeTable.vue?vue&type=template&id=cb41067c"
import script from "./ComparativeTable.vue?vue&type=script&lang=js"
export * from "./ComparativeTable.vue?vue&type=script&lang=js"
import style0 from "./ComparativeTable.vue?vue&type=style&index=0&id=cb41067c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports